import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import ClientAuthPanel from "@/components/auth/ClientAuthPanel";
import { CLIENT_AUTH } from "@/constants/testIds/auth";

/**
 * ClientAuthDialog — modal wrapper around ClientAuthPanel, used by
 * useRequireAuth.js to gate transactional actions on public pages. See
 * docs/auth-and-admin/client-otp-auth-contract.md.
 *
 * There is nothing to compensate for here any more. `components/ui/dialog.jsx`'s
 * DialogContent portals into `document.body` (Radix default), OUTSIDE the DOM subtree
 * templates/shared/TemplateShell.jsx scopes its `--tpl-*` variables to — so this wrapper
 * used to read the resolved theme values off the page's `[data-tpl]` element and re-declare
 * them inline on the portaled content, to keep the panel on-theme. BUG-047 removed the
 * reason: the panel is now a self-contained light card that declares its own palette
 * (`eh-*` literal-hex tokens), because inheriting the theme's colours is precisely what
 * made it unreadable on the dark templates. The dialog therefore only has to be a light
 * surface, which the shared primitive already is; the cream ground below matches the
 * panel's so the modal reads as one card rather than a cream block inside a white one.
 */
export default function ClientAuthDialog({ open, onOpenChange, onSuccess, onBeforeGoogleBridge, initialEmail = "" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={CLIENT_AUTH.dialog} className="sm:max-w-md bg-eh-cream text-eh-ink">
        <ClientAuthPanel
          onSuccess={onSuccess}
          onCancel={() => onOpenChange(false)}
          onBeforeGoogleBridge={onBeforeGoogleBridge}
          initialEmail={initialEmail}
        />
      </DialogContent>
    </Dialog>
  );
}
